export enum StorageKey {
  ADMIN_LOCATION_FILTER = 'cbm-admin-location-filter',
  CREDENTIALS = 'cbm-credentials',
  LOCATION_MODE = 'cbm-locationMode',
  MAP_OPTIONS = 'cbm-mapOptions',
  KEYCLOAK = 'cbm-keycloak',
  KEYCLOAK_CSRF_STATE = 'cbm-keycloak-csrf-state',
  LOCATION_LIST_OF_IDS = 'cbm-location-list-of-ids',
  LOCATION_OVERVIEW_ORIGIN_TYPE = 'cbm-location-overview-origin-type'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/storagekey.ts